export function stringToSlug(input: string, maxLength?: number): string {
  let str = input.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';

  for (let i = 0, l = from.length; i < l; i += 1) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  // Trim to maxLength and remove trailing dashes
  if (maxLength) {
    str = str.substring(0, maxLength);
    str = str.replace(/-+$/, '');
  }

  return str;
}

// Prefixes with `group-` if the slug would otherwise start with a digit.
// Pairs with the `slugStartingWithLetter` schema in lib/schemas/slugs.ts.
export function stringToSlugStartingWithPrefix(
  input: string,
  options?: { maxLength?: number },
): string {
  let str = stringToSlug(input);

  if (/^[0-9]/.test(str)) {
    str = `group-${str}`;
  }

  if (options?.maxLength) {
    str = str.substring(0, options.maxLength);
    str = str.replace(/-+$/, '');
  }

  return str;
}

// Appends a numeric suffix (-2, -3, ...) until the slug doesn't collide with existingSlugs.
export function makeSlugUnique(slug: string, existingSlugs: string[]): string {
  const existingSlugsSet = new Set(existingSlugs);

  if (!existingSlugsSet.has(slug)) {
    return slug;
  }

  let suffix = 2;
  let candidate = `${slug}-${suffix}`;
  while (existingSlugsSet.has(candidate)) {
    suffix += 1;
    candidate = `${slug}-${suffix}`;
  }

  return candidate;
}
